import { TranslocoService } from "@jsverse/transloco";
import { inject, Injectable } from "@angular/core";
import { TitleStrategy, RouterStateSnapshot } from "@angular/router";
import { combineLatest, take } from "rxjs";

@Injectable({
	providedIn: "root",
})
export class TitleService extends TitleStrategy {
	readonly #translateService = inject(TranslocoService);

	override updateTitle(routerState: RouterStateSnapshot): void {
		const leafTitleKey = this.#leafRouteTitleKey(routerState);
		const base$ = this.#translateService.selectTranslate("app_title");

		if (!leafTitleKey) {
			base$.pipe(take(1)).subscribe((base) => {
				document.title = base;
			});
			return;
		}

		combineLatest([base$, this.#translateService.selectTranslate(leafTitleKey)])
			.pipe(take(1))
			.subscribe(([base, page]) => {
				document.title = `${base} - ${page}`;
			});
	}

	override buildTitle(): string | undefined {
		return undefined;
	}

	#leafRouteTitleKey(routerState: RouterStateSnapshot): string {
		let currentRoute = routerState.root;
		let title = "";

		while (currentRoute) {
			if (!currentRoute?.firstChild) {
				title = currentRoute.title ?? "";
				break;
			}

			currentRoute = currentRoute.firstChild;
		}

		return title;
	}
}
